<template>
    <div>
        <!--Input-->
        <div class="flex items-end">
            <div class="w-1/2">
                <!-- Postcode input field -->
                <div :class="postcodeInputClass" class="input--no-margin">
                    <label
                        class="input__label"
                        :for="`${_uid}-postcode`"
                        v-html="$t('POSTCODE_FORM_POSTCODE')"/>
                    <input
                        :id="`${_uid}-postcode`"
                        autocomplete="shipping postal-code"
                        type="text"
                        class="input__field"
                        v-model.lazy="postcode">
                </div>
            </div>
        </div>

        <!--Select & error-->
        <div>
            <div class="w-full input input--invalid">
                <!-- Validation -->
                <p class="input__message"
                   v-if="postcodeEmpty"
                   v-html="$t('POSTCODE_FORM_PLEASE_PUT_POSTCODE')"/>
                <p class="input__message"
                   v-if="!isPostcodeValid || noAddresses"
                   v-html="$t('POSTCODE_FORM_AFRAID_THAT_IS_NOT')"/>
            </div>

            <div v-if="addresses" class="w-full input">
                <!-- Select address dropdown field -->
                <multiselect
                    v-model="selectedAddress"
                    track-by="summaryline"
                    label="summaryline"
                    placeholder="Please select an address"
                    openDirection="below"
                    :allow-empty="false"
                    :show-labels="false"
                    :options="addresses"/>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { formatPostcode, isPostcodeFormatValid } from '@/helpers/PostcodeHelpers';
import PostcodeLookupService from '@/services/logistics/PostcodeLookupService';

export default {
    name: 'PostcodeLookupField',
    data: () => {
        return {
            postcode: null,
            addresses: null,
            selectedAddress: null,
            noAddresses: false,
        };
    },
    props: {
        value: {
            required: true,
        },
        countryIso: {
            required: false,
            default: 'DEU',
        },
    },
    computed: {
        isPostcodeValid() {
            return this.postcode === null || isPostcodeFormatValid(this.postcode);
        },
        isValid() {
            return this.isPostcodeValid && this.noAddresses === false;
        },
        postcodeInputClass() {
            if (this.postcode === null) {
                return 'input';
            }

            return this.isPostcodeValid && this.noAddresses === false && this.postcodeEmpty === false ? 'input input--success' : 'input input--invalid';
        },
        userHasFilled() {
            return this.postcode !== null;
        },
        postcodeEmpty() {
            return this.userHasFilled && (this.postcode || '').length < 1;
        },
    },
    methods: {
        findAvailableAddresses() {
            this.addresses = null;
            this.noAddresses = false;

            if (this.userHasFilled && this.isPostcodeValid) {
                PostcodeLookupService.findAddressesForPostcode(this.postcode, process.env.VUE_APP_POSTCODER_LOCALE)
                    .then(results => {
                        if (results.data.length > 0) {
                            this.addresses = results.data;
                        } else {
                            this.noAddresses = true;
                        }
                    })
                    .catch(error => console.error(error));
            }
        },

        formatPostcode() {
            if (isPostcodeFormatValid(this.postcode)) {
                this.postcode = formatPostcode(this.postcode);
            }
        },
    },
    watch: {
        postcode(value) {
            this.$emit('input', value);
            this.formatPostcode();
            this.noAddresses = false;
        },
        value: {
            immediate: true,
            handler(value) {
                this.postcode = value;
            },
        },
        selectedAddress(address) {
            this.$emit('address-selected', address);
        },
    },
    components: {
        Multiselect,
    },
};
</script>
